<template lang="pug">
modal
	.card.text-left
		.card-header.bg-info.text-white
			span.fa.fa-user.mr-2
			| Insertar registro
			button.close(@click="cerrar") &times;
		.card-body
			h3.mt-3.text-info
				span.fa.fa-info-circle.mr-2
				| Información
			.row
				.col-xs-12.col-sm-12.col-md-12.col-lg-4.col-xl-4
					.form-group
						label Empresa
						input.form-control(placeholder="Nombre de la empresa", v-model="registro.Empresa")
				.col-xs-12.col-sm-12.col-md-12.col-lg-4.col-xl-4
					.form-group
						label E-mail
						input.form-control(placeholder="Email de contacto", v-model="registro.Email")
				.col-xs-12.col-sm-12.col-md-12.col-lg-4.col-xl-4
					.form-group
						label Teléfono
						input.form-control(placeholder="Teléfono de contacto", v-model="registro.Telefono")
			h3.mt-3.text-info
				span.fa.fa-group.mr-2
				| Asistentes
		table.table.table-striped.m-0
			tbody
				tr(
					v-for="(asistente, i) in registro.asistentes"
					:key="asistente.AsistenteID"
				)
					td(style="width:25px;text-align:center;vertical-align:middle;")
						span.fa.fa-user
					td
						input.form-control(placeholder="Nombre", v-model="registro.asistentes[i].Nombre")
					td
						input.form-control(placeholder="Apellidos", v-model="registro.asistentes[i].Apellidos")
					td(style="width:35px;text-align:center;vertical-align:middle;")
						button.btn.btn-danger.btn-sm(v-if="i > 0", @click="delAsistente(i)")
							span.fa.fa-trash
		.card-body
			button.btn.btn-primary(@click="addAsistente")
				span.fa.fa-user.mr-2
				| Añadir asistente
		.card-body
			h3.mt-3.mb-3.text-info
				span.fa.fa-rss.mr-2
				| Como supo del evento
			div(
				v-for="(opcion, i) in listadoOpcionesEnterado"
				:key="i"
			)
				label
					input.mr-3(type="checkbox", @change="setEnterado(opcion, $event)", :checked="registro.enteradoPor.indexOf(opcion) >= 0")
					span(style="cursor:pointer;") {{opcion}}
			textarea.form-control.pl-4(v-if="registro.enteradoPor.indexOf('Otra') >= 0", v-model="registro.enteradoPorOtros", placeholder="Por favor explica donde...")
		.card-body
			h3.mb-3.text-info
				span.fa.fa-gavel.mr-2
				| Protección de datos y comunicaciones
			.alert.alert-warning
				span.fa.fa-exclamation-circle.mr-2
				b.mr-1 LOPD:
				| Al no ser un registro a través del formulario online. Es preciso preguntar al usuario si acepta el tratamiento de los datos que aparece en la política de privacidad,
				|  así como si quiere recibir comunicaciones futuras
			label(style="cursor: pointer;")
				input(type="checkbox", v-model="registro.AceptaComunicaciones")
				| La empresa que se registra me ha dado el consentimiento para recibir futuras comunicaciones por e-mail
		.card-footer
			button.btn.btn-primary.mr-3(@click="insertar")
				span.fa.fa-send.mr-2
				| Guardar empresa
			button.btn.btn-danger(@click="eliminar", v-if="InscritoID")
				span.fa.fa-trash.mr-2
				| Eliminar empresa
</template>

<script>
export default {
	props: ['EventoID', 'InscritoID'],
	data () {
		return {
			registro: {
				Empresa: '',
				Telefono: '',
				Email: '',
				asistentes: [
					{
						AsistenteID: 'Nuevo' + new Date().getTime(),
						nombre: '',
						apellidos: ''
					}
				],
				enteradoPor: [],
				enteradoPorOtros: '',
				EventoID: this.EventoID,
				AceptaComunicaciones: false
			},
			listadoOpcionesEnterado: [
				'Radio',
				'Amigo',
				'Facebook',
				'Página web',
				'Prensa',
				'Otra'
			]
		}
	},
	created () {
		if (this.InscritoID) {
			this.getInscrito()
		}
	},
	methods: {
		getInscrito () {
			this.$http.post('eventos/php/api/getInscripcion.php', {InscritoID: this.InscritoID})
				.then(res => {
					res.data.enteradoPor = res.data.enteradoPor.map(e => e.Nombre)
					this.registro = res.data
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		addAsistente () {
			this.registro.asistentes.push({
				AsistenteID: 'Nuevo' + new Date().getTime(),
				nombre: '',
				apellidos: ''
			})
		},
		delAsistente (i) {
			if (this.registro.asistentes[i].AsistenteID && typeof this.registro.asistentes[i].AsistenteID === 'number') {
				this.$store.commit('alertas/confirm', {
					titulo: 'Atención',
					mensaje: `¿Quieres eliminar este asistente?
					Se invalidará su token en caso de que la asistencia sea numerada`,
					callback: acepta => {
						if (acepta) {
							this.registro.asistentes.splice(i, 1)
							this.$forceUpdate()
						}
					}
				})
			} else {
				this.registro.asistentes.splice(i, 1)
				this.$forceUpdate()
			}
		},
		setEnterado (opcion) {
			const k = this.registro.enteradoPor.indexOf(opcion)
			if (k < 0) {
				this.registro.enteradoPor.push(opcion)
			} else if (k >= 0) {
				this.registro.enteradoPor.splice(k, 1)
			}
			this.$forceUpdate()
		},
		insertar () {
			this.$http.post('eventos/php/api/insertarRegistro.php', this.registro)
				.then(res => {
					this.$store.commit('toast/success', {
						titulo: 'Registro insertado',
						mensaje: 'Has insertado el registro de ' + this.registro.Empresa + ' correctamente'
					})
					this.$emit('actualizar')
					this.cerrar()
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		eliminar () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar empresa',
				mensaje: `¿Quieres eliminar esta empresa y todos sus asistentes de este evento?
				Esta acción no se puede deshacer`,
				callback: acepta => {
					if (acepta) {
						this.$http.post('eventos/php/api/delInscripcion.php', {InscritoID: this.InscritoID})
							.then(res => {
								this.$emit('actualizar')
								this.cerrar()
							})
							.catch(e => {
								this.$store.commit('alertas/error', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/eventos/vue/components/visualizar/insertar.vue